import { Incident } from '@collector/sportsapi-client'

export function resolveIncidentTeamId(
  incident: Pick<Incident, 'participant_team_id' | 'participant_id'>,
): number | null | undefined {
  return incident.participant_team_id ?? incident.participant_id
}
